import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueRouterPrefetch from 'vue-router-prefetch'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
import initProgress from './progressbar'
import VueJwtDecode from 'vue-jwt-decode'
 
// router setup
import routes from './routes/routes'

import authMiddleware from '@/middleware'


// library imports

import './assets/sass/paper-dashboard.scss'
import './assets/sass/demo.scss'

import 'vue-search-select/dist/VueSearchSelect.css'

import sidebarLinks from './sidebarLinks'
import './registerServiceWorker'
// plugin setup
Vue.use(VueRouter)
Vue.use(VueRouterPrefetch)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.use(VeeValidate)
Vue.use(require('vue-cookies'))
Vue.use(VueJwtDecode)
locale.use(lang)

Vue.mixin({
  methods: {
    log_api(type, route, data_send, data_returned) {
      var object = {};

      if(typeof(data_send) == 'object') {
        data_send.forEach((value, key) => {object[key] = value});
        var json_data_sended = JSON.stringify(object);
      } else {
        json_data_sended = data_send;
      }
      var formData = new FormData()
      formData.append('type', type)
      formData.append('route', route)
      formData.append('data_send', JSON.stringify(json_data_sended))
      formData.append('data_returned', JSON.stringify(data_returned))
      fetch(this.$api_url+'/logs', {
          method: "POST",
          credentials: "include",
          body: formData}
      )
    }
  }
})

Vue.prototype.$api_url = 'https://crm-api.solana-eliquides.fr'

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
})
authMiddleware(router)

initProgress(router);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
})
